var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluetooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1253_6470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1253_6470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37501 16.8493V11.5032L5.77241 15.1057C5.65703 15.2211 5.512 15.2802 5.33732 15.2828C5.16266 15.2855 5.01496 15.2265 4.89424 15.1057C4.7735 14.985 4.71313 14.8387 4.71313 14.6667C4.71313 14.4947 4.7735 14.3483 4.89424 14.2276L9.1218 10L4.89424 5.77241C4.77885 5.65704 4.71982 5.51201 4.71716 5.33733C4.71447 5.16266 4.7735 5.01497 4.89424 4.89425C5.01496 4.77351 5.16132 4.71314 5.33332 4.71314C5.50532 4.71314 5.65168 4.77351 5.77241 4.89425L9.37501 8.49683V3.15066C9.37501 2.92203 9.45166 2.7372 9.60497 2.59619C9.75829 2.45516 9.9327 2.38464 10.1282 2.38464C10.2233 2.38464 10.3154 2.4028 10.4046 2.43912C10.4938 2.47546 10.5774 2.53262 10.6554 2.6106L13.9343 5.88943C14.0123 5.96742 14.0673 6.04969 14.0993 6.13623C14.1314 6.22275 14.1474 6.31623 14.1474 6.41666C14.1474 6.51709 14.1314 6.61057 14.0993 6.6971C14.0673 6.78364 14.0123 6.86591 13.9343 6.94389L10.8782 10L13.9343 13.0561C14.0123 13.1341 14.0673 13.2164 14.0993 13.3029C14.1314 13.3894 14.1474 13.4829 14.1474 13.5833C14.1474 13.6838 14.1314 13.7772 14.0993 13.8638C14.0673 13.9503 14.0123 14.0326 13.9343 14.1106L10.6554 17.3894C10.5774 17.4674 10.4938 17.5245 10.4046 17.5609C10.3154 17.5972 10.2233 17.6154 10.1282 17.6154C9.9327 17.6154 9.75829 17.5448 9.60497 17.4038C9.45166 17.2628 9.37501 17.078 9.37501 16.8493ZM10.625 8.49683L12.7051 6.41666L10.625 4.36214V8.49683ZM10.625 15.6379L12.7051 13.5833L10.625 11.5032V15.6379Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.7d2bbd569ca459c047324a2ad75ff221.svg";
export { ForwardRef as ReactComponent };